import styled from "styled-components";
import tw from "twin.macro";
import { usePostValue } from "../../..";
import { DP } from "../../../../../common/types";

interface Props extends DP {}

const CloudinaryVideoPlayer = (props: Props) => {

  const videoUrl = usePostValue((s) => s.post.videoId);
	const thumbnail = usePostValue((s) => s.post.thumbnail)

  return (
    <Video
			poster={thumbnail}
      src={videoUrl}
      controls
      id={"main-video"}
			preload={'metadata'}
      className= {props.className}
    />
  );
};

const Video = styled.video(() => [tw`w-full rounded-sm aspect-video`]);

export default styled(CloudinaryVideoPlayer)``;
